import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { EnvironmentService } from '@services/environment/environment.service';
import { BrandsEnum } from '@models/enums/brands.enum';
import { AppSettingsService } from '@services/app-settings/app-settings.service';

export const brandGuard: CanActivateFn = (route, _state) => {
  const appSettingsService = inject(AppSettingsService);
  const brandSignal = appSettingsService.brandSig;
  const brandFromQuery = route.queryParams['brand'] as BrandsEnum | undefined;

  if (brandSignal() !== null) {
    // The brand is already set, do nothing.
  } else if (!EnvironmentService.environment.production && brandFromQuery) {
    brandSignal.set(appSettingsService.ensureBrandEnumValue(brandFromQuery));
  } else {
    appSettingsService.setBrandByHostname();
  }

  return true;
};
